<template>
    <div class="container">
        Errors: {{ errors }}
        <div class="row">
            <div class="col">
                <b-form-select v-model="selected" :options="options" class="mb-3">
                    <template v-slot:first>
                        <b-form-select-option :value="null" disabled>-- Please select query --</b-form-select-option>
                    </template>
                </b-form-select>
            </div>
            <div class="col">
                <b-form-select v-model="limitSelected" :options="limitOptions" class="mb-3"></b-form-select>
            </div>
            <div class="col-auto">
                <button
                    type="button"
                    class="btn btn-block btn-success"
                    @click="newQuery()"
                >New Query</button>
            </div>
        </div>
        <div class="row">
            <div class="col-auto">
                <b-form-checkbox v-model="blacklist" name="check-button" switch>
                    Auch mit BL-Flag
                    <b>(Checked: {{ blacklist }})</b>
                </b-form-checkbox>
            </div>
            <div class="col">
                <b-form-checkbox v-model="notice" name="check-button" switch>
                    Auch mit ML-Flag
                    <b>(Checked: {{ notice }})</b>
                </b-form-checkbox>
            </div>
        </div>
        <div class="row mb-5" v-if="createMode || selected !== null">
            <div class="col">
                <input
                    v-model="label"
                    type="text"
                    class="form-control mb-2"
                    placeholder="Label..."
                    v-if="createMode"
                />
                <textarea
                    v-model="statement"
                    class="form-control mb-2"
                    placeholder="Query..."
                    rows="3"
                ></textarea>
                <div class="row">
                    <div class="col" v-if="editMode">
                        <button type="button" class="btn btn-block btn-danger" @click="remove()">
                            <b-icon icon="trash"></b-icon>Delete
                        </button>
                    </div>
                    <div class="col" v-if="editMode">
                        <button
                            type="button"
                            class="btn btn-block btn-outline-success"
                            @click="update()"
                        >
                            <b-icon icon="cloud-upload"></b-icon>Update
                        </button>
                    </div>
                    <div class="col" v-if="!editMode">
                        <button type="button" class="btn btn-block btn-success" @click="create()">
                            <b-icon icon="cloud-upload"></b-icon>Save
                        </button>
                    </div>
                    <div class="col">
                        <div v-if="loading">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div v-else>
                            <button
                                type="button"
                                class="btn btn-block btn-primary"
                                @click="execute()"
                            >
                                <b-icon icon="play-fill"></b-icon>Run
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="row">
                <div class="col">
                    <label>Downloads greater or equal</label>
                    <b-form-select
                        v-model="criteria.downloadsFrom.value"
                        :options="downloadsFromOptions"
                        class="mb-3"
                    ></b-form-select>
                </div>
                <div class="col">
                    <label>Downloads smaller or equal</label>
                    <b-form-select
                        v-model="criteria.downloadsTo.value"
                        :options="downloadsToOptions"
                        class="mb-3"
                    ></b-form-select>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label>Rating count from:</label>
                    <input
                        v-model="criteria.ratingCountFrom.value"
                        type="text"
                        class="form-control mb-2"
                    />
                </div>
                <div class="col">
                    <label>Rating count to:</label>
                    <input
                        v-model="criteria.ratingCountTo.value"
                        type="text"
                        class="form-control mb-2"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label>Review count from:</label>
                    <input
                        v-model="criteria.reviewCountFrom.value"
                        type="text"
                        class="form-control mb-2"
                    />
                </div>
                <div class="col">
                    <label>Review count to:</label>
                    <input
                        v-model="criteria.reviewCountTo.value"
                        type="text"
                        class="form-control mb-2"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label>Age in months from:</label>
                    <input v-model="criteria.ageFrom.value" type="text" class="form-control mb-2" />
                </div>
                <div class="col">
                    <label>Age in months to:</label>
                    <input v-model="criteria.ageTo.value" type="text" class="form-control mb-2" />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div>
                        <label for="range-1">
                            Score from:
                            <strong>{{ criteria.scoreFrom.value }}</strong>
                        </label>
                        <b-form-input
                            id="range-1"
                            v-model="criteria.scoreFrom.value"
                            type="range"
                            min="0"
                            max="5"
                            step="0.1"
                        ></b-form-input>
                    </div>
                </div>
                <div class="col">
                    <div>
                        <label for="range-1">
                            Score to:
                            <strong>{{ criteria.scoreTo.value }}</strong>
                        </label>
                        <b-form-input
                            id="range-1"
                            v-model="criteria.scoreTo.value"
                            type="range"
                            min="0"
                            max="5"
                            step="0.1"
                        ></b-form-input>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="items.length">
            <input
                type="text"
                class="form-control mb-3"
                v-model="filter"
                placeholder="Fulltext search..."
            />
            Total results:
            <strong>{{ items.length }}</strong>
            <b-table
                sticky-header
                show-empty
                striped
                bordered
                head-variant="light"
                stacked="md"
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
                @row-clicked="onRowClicked"
            >
                <template v-slot:cell(appId)="row">
                    <a :href="row.item.url" target="_blank">
                        <img :src="row.item.icon" width="50px" />
                        <br />
                        {{ row.item.title }}
                        <br />
                        <small>{{ row.item.appId }}</small>
                    </a>
                </template>
                <template v-slot:cell(developer)="row">
                    <a
                        :href="
                            'https://play.google.com/store/apps/developer?id=' +
                                row.item.developerId +
                                '&hl=en&gl=us'
                        "
                    >{{ row.item.developer }}</a>
                    <br />
                    <small>{{ row.item.developerEmail }}</small>
                </template>
                <template v-slot:cell(actions)="row">
                    <div style="width: 80px">
                        <button
                            type="button"
                            class="btn btn-sm btn-dark"
                            @click="setBlacklistApp(row.item.appId)"
                        >
                            <b-icon icon="x-circle"></b-icon>
                        </button>
                        <button
                            type="button"
                            class="btn btn-sm btn-primary ml-1"
                            @click="setNoticeApp(row.item.appId)"
                        >
                            <b-icon icon="heart"></b-icon>
                        </button>
                    </div>
                </template>
            </b-table>
            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
            ></b-pagination>
        </div>
        <b-modal v-model="modalShow" size="xl" class="modal-fullscreen2">
            <template v-slot:modal-title>Apps von {{ modal.developer.title }}</template>
            <div class="row mb-2">
                <div class="col">{{ items2.length }} Ergebnisse</div>
            </div>
            <div class="row mb-2">
                <div class="col-auto">
                    <button
                        type="button"
                        class="btn btn-dark"
                        @click="setBlacklistDev(row.item.developerId)"
                    >Developer auf Blacklist</button>
                </div>
                <div class="col-auto">
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="setNoticeDev(row.item.developerId)"
                    >Alle Apps auf Merkliste</button>
                </div>
                <div class="col">
                    <a
                        :href="
                            'https://play.google.com/store/apps/developer?id=' +
                                modal.developer.url +
                                '&hl=en&gl=us'
                        "
                        class="btn btn-light"
                    >Playstore</a>
                </div>
            </div>
            <b-table
                sticky-header
                show-empty
                striped
                bordered
                head-variant="light"
                stacked="md"
                :items="items2"
                :fields="fields2"
                :current-page="currentPage"
                :per-page="'500'"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
            >
                <template v-slot:cell(appId)="row">
                    <a :href="row.item.url" target="_blank">
                        <img :src="row.item.icon" width="50px" />
                        <br />
                        {{ row.item.title }}
                        <br />
                        <small>{{ row.item.appId }}</small>
                    </a>
                </template>
                <template v-slot:cell(developer)="row">
                    <a
                        :href="
                            'https://play.google.com/store/apps/developer?id=' +
                                row.item.developerId +
                                '&hl=en&gl=us'
                        "
                    >{{ row.item.developer }}</a>
                    <br />
                    <small>{{ row.item.developerEmail }}</small>
                </template>
                <template v-slot:cell(actions)="row">
                    <div style="width: 80px">
                        <button
                            type="button"
                            class="btn btn-sm btn-dark"
                            @click="setBlacklisted(row.item)"
                        >
                            <b-icon icon="x-circle"></b-icon>
                        </button>
                        <button
                            type="button"
                            class="btn btn-sm btn-primary ml-1"
                            @click="setBlacklisted(row.item)"
                        >
                            <b-icon icon="heart"></b-icon>
                        </button>
                    </div>
                </template>
            </b-table>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            blacklist: true,
            notice: true,

            modalShow: false,
            modal: {
                selected: '',
                developer: {
                    title: ''
                }
            },
            operators: {
                '>=': function(a, b) {
                    return a >= b
                },
                '<=': function(a, b) {
                    return a <= b
                },
                '==': function(a, b) {
                    return a == b
                }
            },
            todo: [],
            criteria: {
                downloadsFrom: {
                    prop: 'installs',
                    operator: '>=',
                    value: null
                },
                downloadsTo: {
                    prop: 'installs',
                    operator: '<=',
                    value: null
                },
                ratingCountFrom: {
                    prop: 'ratings',
                    operator: '>=',
                    value: 0
                },
                ratingCountTo: {
                    prop: 'ratings',
                    operator: '<=',
                    value: null
                },
                reviewCountFrom: {
                    prop: 'reviews',
                    operator: '>=',
                    value: 0
                },
                reviewCountTo: {
                    prop: 'reviews',
                    operator: '<=',
                    value: null
                },
                scoreFrom: {
                    prop: 'score',
                    operator: '>=',
                    value: 0
                },
                scoreTo: {
                    prop: 'score',
                    operator: '<=',
                    value: 5
                },
                ageFrom: {
                    prop: 'months',
                    operator: '>=',
                    value: 0
                },
                ageTo: {
                    prop: 'months',
                    operator: '<=',
                    value: null
                },
                blacklisted: {
                    prop: 'blacklisted',
                    operator: '==',
                    value: false
                },
                noticed: {
                    prop: 'noticed',
                    operator: '==',
                    value: false
                }
            },

            downloadsFromSelected: 0,
            downloadsFromOptions: [],
            downloadsToSelected: 0,
            downloadsToOptions: [],

            loading: false,
            createMode: false,
            editMode: false,
            selected: null,
            options: [],
            limitOptions: [
                {
                    text: 'LIMIT: 100',
                    value: 100
                },
                {
                    text: 'LIMIT: 250',
                    value: 250
                },
                {
                    text: 'LIMIT: 500',
                    value: 500
                },
                {
                    text: 'LIMIT: 1000',
                    value: 1000
                },
                {
                    text: 'LIMIT: 2500',
                    value: 2500
                },
                {
                    text: 'LIMIT: 5000',
                    value: 5000
                },
                {
                    text: 'LIMIT: 10000',
                    value: 10000
                }
            ],
            limitSelected: 1000,

            statement: '',
            label: '',
            id: '',
            errors: [],

            items: [],
            itemsOriginal: [],
            items2: [],
            fields: [],
            fields2: [],
            totalRows: 1,
            currentPage: 1,
            perPage: 100,
            sortBy: '',
            sortDesc: false,
            sortDirection: 'asc',
            filter: null
        }
    },
    watch: {
        criteria: {
            deep: true,
            handler() {
                this.filterItems()
            }
        },
        selected(n) {
            if (n !== null) {
                this.editMode = true

                let temp = this.options.find(option => option.value == n).data
                this.statement = temp.query
                this.id = temp.id
            } else {
                this.editMode = false
            }
        }
    },
    computed: {},
    mounted() {
        this.load()
        this.getFilter()
    },
    methods: {
        filterItems() {
            this.todo = []
            this.items = this.itemsOriginal
            for (var c in this.criteria) {
                if (
                    this.items.length > 0 &&
                    this.criteria[c].prop in this.items[0] &&
                    this.criteria[c].value !== null &&
                    this.criteria[c].value != ''
                ) {
                    this.todo.push(this.criteria[c])
                }
            }
            for (var c of this.todo) {
                this.items = this.items.filter(item => {
                    return this.operators[c.operator](item[c.prop], c.value)
                })
            }
            this.totalRows = this.items.length
        },
        newQuery() {
            this.createMode = true
            this.statement = ''
            this.label = ''
            this.selected = null
        },
        getFilter() {
            axios
                .get(`https://ps.hlogo.de/lumen/public/filter`)
                .then(response => {
                    this.downloadsFromOptions = response.data.downloads
                    this.downloadsToOptions = response.data.downloads
                })
                .catch(e => {
                    this.errors.push(e)
                })
        },
        create() {
            axios
                .get(
                    `https://ps.hlogo.de/lumen/public/create?q=` +
                        btoa(this.statement) +
                        '&l=' +
                        btoa(this.label)
                )
                .then(response => {
                    this.options = response.data
                    this.selected =
                        response.data[response.data.length - 1].data.id
                })
                .catch(e => {
                    this.errors.push(e)
                })
        },
        update() {
            axios
                .get(
                    `https://ps.hlogo.de/lumen/public/update?q=` +
                        btoa(this.statement) +
                        '&l=' +
                        btoa(this.label) +
                        '&id=' +
                        this.id
                )
                .then(response => {
                    this.options = response.data
                    this.selected =
                        response.data[response.data.length - 1].data.id
                })
                .catch(e => {
                    this.errors.push(e)
                })
        },
        remove() {
            axios
                .get(`https://ps.hlogo.de/lumen/public/delete?id=` + this.id)
                .then(response => {
                    this.options = response.data
                    this.selected = null
                })
                .catch(e => {
                    this.errors.push(e)
                })
        },
        load() {
            axios
                .get(`https://ps.hlogo.de/lumen/public/statements`)
                .then(response => {
                    this.options = response.data
                })
                .catch(e => {
                    this.errors.push(e)
                })
        },
        execute() {
            this.loading = true

            axios
                .get(
                    `https://ps.hlogo.de/lumen/public/statement?q=` +
                        btoa(this.statement) +
                        `&limit=` +
                        this.limitSelected
                )
                .then(response => {
                    this.fields = []
                    this.items = response.data.items
                    if (this.items.length) {
                        for (var k in this.items[0]) {
                            if (
                                k != 'icon' &&
                                k != 'noticed' &&
                                k != 'url' &&
                                k != 'title' &&
                                k != 'developerEmail' &&
                                k != 'developerId'
                            ) {
                                this.fields.push({
                                    key: k,
                                    sortable: true
                                })
                            }
                        }
                        this.fields.push({
                            key: 'actions',
                            sortable: false
                        })
                    }

                    this.itemsOriginal = this.items
                    this.totalRows = this.items.length
                    this.loading = false
                })
                .catch(e => {
                    this.errors.push(e.message)
                    this.loading = false
                })
        },
        setBlacklistApp(id) {
            this.loading = true
            axios
                .get(
                    `https://ps.hlogo.de/lumen/public/blacklist?type=app&id=` +
                        btoa(id)
                )
                .then(response => {
                    console.log(response.data)
                    this.loading = false
                })
                .catch(e => {
                    this.errors.push(e.message)
                    this.loading = false
                })
        },
        setNoticeApp(id) {
            this.loading = true
            axios
                .get(
                    `https://ps.hlogo.de/lumen/public/notice?type=app&id=` +
                        btoa(id)
                )
                .then(response => {
                    console.log(response.data)
                    this.loading = false
                })
                .catch(e => {
                    this.errors.push(e.message)
                    this.loading = false
                })
        },
        setBlacklistDev(id) {
            this.loading = true
            axios
                .get(
                    `https://ps.hlogo.de/lumen/public/blacklist?type=developer&id=` +
                        btoa(id)
                )
                .then(response => {
                    console.log(response.data)
                    this.loading = false
                })
                .catch(e => {
                    this.errors.push(e.message)
                    this.loading = false
                })
        },
        setNoticeDev(id) {
            this.loading = true
            axios
                .get(
                    `https://ps.hlogo.de/lumen/public/notice?type=developer&id=` +
                        btoa(id)
                )
                .then(response => {
                    console.log(response.data)
                    this.loading = false
                })
                .catch(e => {
                    this.errors.push(e.message)
                    this.loading = false
                })
        },
        getDeveloperInfos() {
            this.loading = true
            axios
                .get(
                    `https://ps.hlogo.de/lumen/public/developer?id=` +
                        btoa(this.modal.selected)
                )
                .then(response => {
                    this.items2 = response.data
                    if (this.items2.length) {
                        for (var k in this.items2[0]) {
                            if (
                                k != 'icon' &&
                                k != 'noticed' &&
                                k != 'url' &&
                                k != 'title' &&
                                k != 'developerEmail' &&
                                k != 'developer' &&
                                k != 'developerId'
                            ) {
                                this.fields2.push({
                                    key: k,
                                    sortable: true
                                })
                            }
                        }
                        this.fields2.push({
                            key: 'actions',
                            sortable: false
                        })
                        this.modal.developer.title = this.items2[0].developer
                        this.modal.developer.url = this.items2[0].developerId
                    }
                    this.loading = false
                })
                .catch(e => {
                    this.errors.push(e.message)
                    this.loading = false
                })
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        onRowClicked(item, index) {
            this.modalShow = true
            this.modal.selected = item.developerId
            this.getDeveloperInfos()
            console.log(item, index)
        }
    }
}
</script>
